import React, { Fragment } from "react";
import DiscussionParticipantItem from "./DiscussionParticipantItem";

const DiscussionParticipants = ({
  discussions,
  removeParticipant,
  setParticipant,
}) => {
  return (
    <Fragment>
      <div className="side-container border-right grey">
        <div className="online-title-container-alt">
          <div className="border-alt green">
            <p className="online-title-alt green">
              <i className="fas fa-users green mr-5"></i>Participants
            </p>
          </div>
        </div>
        <div className="all-users">
          {discussions && discussions.length > 0 ? (
            discussions.map((participant) => {
              return (
                <DiscussionParticipantItem
                  key={participant.channelid}
                  participant={participant}
                  removeParticipant={removeParticipant}
                  setParticipant={setParticipant}
                />
              );
            })
          ) : (
            <div className="empty-side-container">
              <p className="empty-content-alt-dark green bold">
                No Participants
              </p>
            </div>
          )}
        </div>
      </div>
    </Fragment>
  );
};

export default DiscussionParticipants;
